import {Guide, getPrivateAxios} from '@blesk-frontend/api';
/**
 *
 * @param guide
 */
export const fetchGuideRestore = async (guide: Pick<Guide, 'id'>) => {
  const {data} = await getPrivateAxios().post<void>(`/guides/${guide.id}/restore`);
  return data;
};
